import { LoginAction } from "COMPONENTS/Login/LoginAction";
import { CreateSessionAction } from "COMPONENTS/Sessions/SessionActions";
import { StartSessionAction } from "COMPONENTS/SessionManagement/StartSession/StartSessionAction";
import { LeaveSessionAction } from "COMPONENTS/LeaveSession/LeaveSessionAction";
import { ScheduleSessionAction } from "COMPONENTS/SessionManagement/ScheduleSession/ScheduleSessionAction";
import { WhiteboardAction } from "COMPONENTS/Whiteboard/WhiteboardAction";
import { LogoutAction } from "COMPONENTS/Header/LogoutAction";
import { HeaderAction } from "COMPONENTS/CommonComponents/Header/HeaderAction";
import { AudioVideoAction } from "COMPONENTS/Video/AudioVideoAction";
import { ResetPasswordAction } from "COMPONENTS/ResetPassword/ResetPasswordAction";
import { SetPasswordAction } from "COMPONENTS/SetPassword/SetPasswordAction";
import { OrganisationAction } from "COMPONENTS/SuperAdmin/Organisations/OrganisationAction";
import { UserAction } from "COMPONENTS/SuperAdmin/Users/UserAction";
import { UserProfileAction } from "COMPONENTS/UpdateProfile/UpdateProfileAction";
import { AddInviteeAction } from "COMPONENTS/AddInvitee/AddInviteeAction";
import { AppEmulationAction } from "COMPONENTS/AppEmulation/AppEmulationAction";
import { ChangePasswordAction } from "COMPONENTS/ChangePassword/ChangePasswordAction";
import { SystemAnnouncementAction } from "../Components/SuperAdmin/SystemAnnouncements/SystemAnnoucementActions";
import { CustomerCoBrowseAction } from "COMPONENTS/CustomerCoBrowse/CustomerCoBrowseAction"
import { CustomerCoBrowseActionV2 } from "COMPONENTS/CustomerCoBrowseV2/CustomerCoBrowseActionV2"
import { InboundCoBrowseAction } from "@/Components/InboundCoBrowse/InboundCoBrowseAction"
import { WaitingUsersAction } from "COMPONENTS/SessionManagement/WaitingUsers/WaitingUsersAction"
import { CallWaitingAction } from "COMPONENTS/SupportCenter/CallWaiting/CallWaitingAction";

export const loginAction = new LoginAction();
export const sessionActions = new CreateSessionAction();
export const startSessionAction = new StartSessionAction();
export const leaveSessionAction = new LeaveSessionAction();
export const scheduleSessionAction = new ScheduleSessionAction();
export const whiteboardAction = new WhiteboardAction();
export const logoutAction = new LogoutAction();
export const headerAction = new HeaderAction();
export const audioVideoAction = new AudioVideoAction();
export const resetPasswordAction = new ResetPasswordAction();
export const setPasswordAction = new SetPasswordAction();
export const organisationAction = new OrganisationAction();
export const systemAnnouncementAction = new SystemAnnouncementAction();
export const userAction = new UserAction();
export const userProfileAction = new UserProfileAction();
export const inviteeAction = new AddInviteeAction();
export const appEmulationAction = new AppEmulationAction();
export const changePasswordAction = new ChangePasswordAction();
export const customerCoBrowseAction = new CustomerCoBrowseAction();
export const customerCoBrowseActionV2 = new CustomerCoBrowseActionV2();
export const inboundCoBrowseAction = new InboundCoBrowseAction();
export const waitingUsersAction = new WaitingUsersAction();
export const callWaitingAction = new CallWaitingAction();